import { render } from "./FiguresPage.vue?vue&type=template&id=6a0b9844&ts=true"
import script from "./FiguresPage.vue?vue&type=script&lang=ts"
export * from "./FiguresPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__